import { useEffect, useState } from 'react';

interface SkeletonColors {
    color: string;
    highlightColor: string;
}

interface SkeletonThemeColors {
    base: SkeletonColors;
    xs: SkeletonColors;
}

const getCSSVar = (name: string): string =>
    getComputedStyle(document.documentElement).getPropertyValue(name).trim();

const readSkeletonColors = (): SkeletonThemeColors => ({
    base: {
        color: getCSSVar('--cds-skeleton-color') || process.env.REACT_APP_SKELETON_COLOR || '#202020',
        highlightColor: getCSSVar('--cds-skeleton-highlight') || process.env.REACT_APP_SKELETON_HIHGLIGHTS_COLOR || '#272727',
    },
    xs: {
        color: getCSSVar('--cds-skeleton-xs-color') || process.env.REACT_APP_SKELETON_XS_COLOR || '#1b1b1b',
        highlightColor: getCSSVar('--cds-skeleton-xs-highlight') || process.env.REACT_APP_SKELETON_XS_HIHGLIGHTS_COLOR || '#2a2a2a',
    },
});

/**
 * Returns skeleton colors that react to the current `data-theme` attribute.
 * Falls back to env vars for backwards compatibility.
 */
const useSkeletonTheme = (): SkeletonThemeColors => {
    const [colors, setColors] = useState<SkeletonThemeColors>(readSkeletonColors);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setColors(readSkeletonColors());
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme'],
        });

        return () => observer.disconnect();
    }, []);

    return colors;
};

export default useSkeletonTheme;
